import * as React from 'react';
import {History} from 'history';
import {AsYouType, parsePhoneNumberFromString} from 'libphonenumber-js';
import {handleInputChangeWrapper} from '../../helpers/state';
import {IOrganization} from '../../services/account';
import {PropagateLoader} from 'react-spinners';

import a from '../../images/1.jpg';
import b from '../../images/2.jpg';
import c from '../../images/3.jpg';

import './styles.css';
import {
    FormattedMessage,
    InjectedIntlProps,
    injectIntl,
    defineMessages,
    FormattedHTMLMessage,
} from 'react-intl';
import {FileSelector} from '../../shared/FileSelector';
import states from '../../data/states.js';

interface IState {
    logo: File | null;
    hasBeenSubmitted: boolean;
    fields: IOrganizationForm;
    saving: boolean;
}
type IFormat = (value: string | null) => string | null;
interface IOrganizationForm {
    orgName: IInput;
    addressLine1: IInput;
    addressLine2: IInput;
    city: IInput;
    zip: IInput;
    state: IInput;
    phone: IInput;
    website: IInput;
    email: IInput;
    avatar: IInput;
}
interface IInput {
    value: null | string;
    isValid: () => boolean;
    format: undefined | IFormat;
}
interface IProps {
    history: History;
    createOrganization: (org: IOrganization, file: File | null) => void;
    handleBack: (state: any) => void;
    state: any;
}

const presetIcons = [a, b, c];

class CreateOrganization extends React.Component<IProps & InjectedIntlProps, IState> {
    messages = defineMessages({
        orgName: {
            id: 'signup.org.name.placeholder',
            defaultMessage: 'Organization Name',
        },
        addrLine1: {
            id: 'signup.org.addr.line1.placeholder',
            defaultMessage: 'Line One',
        },
        addrLine2: {
            id: 'signup.org.addr.line2.placeholder',
            defaultMessage: 'Line Two',
        },
        city: {
            id: 'signup.org.addr.city.placeholder',
            defaultMessage: 'City',
        },
        zip: {
            id: 'signup.org.addr.zip.placeholder',
            defaultMessage: 'Zip Code',
        },
        state: {
            id: 'signup.org.addr.state.placeholder',
            defaultMessage: 'State',
        },
        phoneFormat: {
            id: 'signup.org.phone.placeholder',
            defaultMessage: '(###) ###-####',
        },
    });

    state = {
        hasBeenSubmitted: false,
        saving: false,
        logo: null,
        fields: {
            orgName: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.orgName.value;
                    }
                    return this.state.fields.orgName.value !== '';
                },
                format: undefined,
            },
            avatar: {
                value: null,
                isValid: () => {
                    return true;
                    // if (this.state.hasBeenSubmitted) {
                    //     return !!this.state.fields.avatar.value;
                    // }
                    // return this.state.fields.avatar.value !== '';
                },
                format: undefined,
            },
            addressLine1: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.addressLine1.value;
                    }
                    return this.state.fields.addressLine1.value !== '';
                },
                format: undefined,
            },
            addressLine2: {
                value: null,
                isValid: () => {
                    return true;
                },
                format: undefined,
            },
            city: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.city.value;
                    }
                    return this.state.fields.city.value !== '';
                },
                format: undefined,
            },
            zip: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return (
                            !!this.state.fields.zip.value &&
                            (this.state.fields.zip.value || '').length === 5
                        );
                    }
                    return this.state.fields.zip.value !== '';
                },
                format: undefined,
            },
            state: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        return !!this.state.fields.state.value;
                    }
                    return this.state.fields.state.value !== '';
                },
                format: undefined,
            },
            phone: {
                value: null,
                isValid: () => {
                    if (this.state.hasBeenSubmitted) {
                        if (!this.state.fields.phone.value) return false;
                        const phoneNumber = parsePhoneNumberFromString(
                            this.state.fields.phone.value || '',
                            'US'
                        );
                        if (
                            !!this.state.fields.phone.value &&
                            phoneNumber &&
                            !phoneNumber.isValid()
                        )
                            return false;
                    }
                    return this.state.fields.phone.value !== '';
                },
                format: (value: string | null) => new AsYouType('US').input(value || ''),
            },
            email: {
                value: null,
                isValid: () => {
                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return (
                        (!this.state.hasBeenSubmitted && this.state.fields.email.value === null) ||
                        re.test(String(this.state.fields.email.value).toLowerCase())
                    );
                },
                format: undefined,
            },
            website: {
                value: null,
                isValid: () => {
                    return this.state.fields.website.value !== '';
                },
                format: undefined,
            },
        },
    };

    handleInputChange = handleInputChangeWrapper(this);

    handleLogoChange = (logo: File) => this.setState({logo});

    renderPresetIcons = () =>
        presetIcons.map((x, i) => {
            return (
                <div key={x} className="form-check form-check-inline">
                    <input
                        className="form-check-input"
                        type="radio"
                        name={`presetIcon`}
                        id={`img-${i}`}
                        value={x}
                    />
                    <label className="form-check-label" htmlFor={`img-${i}`}>
                        <img className="rounded" src={x} width={50} height={50} />
                    </label>
                </div>
            );
        });

    handleSave = () => {
        this.setState({hasBeenSubmitted: true, saving: true}, async () => {
            let isValid = true;
            Object.keys(this.state.fields).forEach((item: string) => {
                if (this.state.fields[item].isValid) {
                    if (!this.state.fields[item].isValid(true)) {
                        isValid = false;
                    }
                }
            });
            if (isValid) {
                const organization = {
                    address: {
                        firstLine: this.state.fields.addressLine1.value || '',
                        secondLine: this.state.fields.addressLine2.value || '',
                        state: this.state.fields.state.value || '',
                        city: this.state.fields.city.value || '',
                        zipCode: this.state.fields.zip.value || '',
                    },
                    email: this.state.fields.email.value || '',
                    website: this.state.fields.website.value || '',
                    orgName: this.state.fields.orgName.value || '',
                    phone: this.state.fields.phone.value || '',
                    avatar: this.state.fields.avatar.value || '',
                };
                await this.props.createOrganization(organization, this.state.logo);
            } else {
                console.error('Invalid Organization', this.state.fields);
            }
            this.setState({saving: false});
        });
    };

    renderSubmit = () => {
        if (this.state.saving) {
            return (
                <div className="p-5 d-flex justify-content-center">
                    <PropagateLoader size={15} loading={this.state.saving} color="#29447b" />
                </div>
            );
        }
        return (
            <React.Fragment>
                <button className="primary" onClick={this.handleSave}>
                    <FormattedMessage id="button.signup.submit" defaultMessage="Submit" />
                </button>
                <button className="btn btn-link" onClick={() => this.props.handleBack(this.state)}>
                    <FormattedMessage id="button.signup.back" defaultMessage="Back" />
                </button>
            </React.Fragment>
        );
    };

    componentDidMount() {
        if (this.props.state) {
            const fields = {...this.state.fields};
            Object.keys(fields).forEach((key) => {
                fields[key] = {
                    ...fields[key],
                    value:
                        this.props.state && this.props.state.fields && this.props.state.fields[key]
                            ? this.props.state.fields[key].value
                            : null,
                };
            });
            this.setState({fields});
        }
    }

    render() {
        return (
            <section className="px-5 signupOrg">
                <div className="container">
                    <div className="row mt-5">
                        <div className="page-title">
                            <h2>
                                <FormattedMessage
                                    id="signup.org.hdr"
                                    defaultMessage="Almost there!"
                                />
                            </h2>
                            <FormattedHTMLMessage
                                id="signup.org.txt"
                                defaultMessage={`<p>Almost there! Thank you for registering your account.</p>
                            <p>Please enter your organization's details below. This information will be viewable by other Harmonize® users.</p>
                            <br/>`}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <h3 className="harmonize col">
                            <FormattedMessage
                                id="signup.org.info.hdr"
                                defaultMessage="Step 2: Organization Information"
                            />
                        </h3>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="form-row">
                                <div className="col-md">
                                    <label className="text-muted" htmlFor="orgName">
                                        <FormattedMessage
                                            id="signup.org.name.label"
                                            defaultMessage="Name"
                                        />
                                    </label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.orgName.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                        }`}
                                        name="orgName"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(
                                            this.messages.orgName
                                        )}
                                        value={this.state.fields.orgName.value || ''}
                                        required
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage
                                            id="signup.org.name.req"
                                            defaultMessage="Organization name is required."
                                        />
                                    </div>
                                </div>
                            </div>
                            <fieldset>
                                <div className="form-row mt-5">
                                    <legend className="text-muted">
                                        <FormattedMessage
                                            id="signup.org.addr.label"
                                            defaultMessage="Address"
                                        />
                                    </legend>
                                    <div className="col-sm-6">
                                        <input
                                            className={`form-control ${
                                                this.state.fields.addressLine1.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                            }`}
                                            name="addressLine1"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            value={this.state.fields.addressLine1.value || ''}
                                            placeholder={this.props.intl.formatMessage(
                                                this.messages.addrLine1
                                            )}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="signup.org.addr.req"
                                                defaultMessage="Address is required."
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <input
                                            className={`form-control`}
                                            name="addressLine2"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            placeholder={this.props.intl.formatMessage(
                                                this.messages.addrLine2
                                            )}
                                            value={this.state.fields.addressLine2.value || ''}
                                        />
                                    </div>
                                </div>
                                <div className="form-row mt-2">
                                    <div className="col-sm">
                                        <input
                                            className={`form-control ${
                                                this.state.fields.city.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                            }`}
                                            name="city"
                                            onChange={this.handleInputChange}
                                            type="text"
                                            placeholder={this.props.intl.formatMessage(
                                                this.messages.city
                                            )}
                                            value={this.state.fields.city.value || ''}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="signup.org.city.req"
                                                defaultMessage="City is required."
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm">
                                        <select
                                            value={this.state.fields.state.value || ''}
                                            className={`form-control custom-select ${
                                                this.state.fields.state.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                            }`}
                                            name="state"
                                            onChange={this.handleInputChange}
                                            placeholder={this.props.intl.formatMessage(
                                                this.messages.state
                                            )}>
                                            <option value="">
                                                {this.props.intl.formatMessage(this.messages.state)}
                                            </option>
                                            {states.map(
                                                (state: {name: string; abbreviation: string}) => (
                                                    <option
                                                        value={state.name}
                                                        key={state.abbreviation}>
                                                        {state.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="signup.org.state.req"
                                                defaultMessage="State is required."
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm">
                                        <input
                                            className={`form-control ${
                                                this.state.fields.zip.isValid() === false
                                                    ? 'is-invalid'
                                                    : ''
                                            }`}
                                            name="zip"
                                            onChange={this.handleInputChange}
                                            type="number"
                                            placeholder={this.props.intl.formatMessage(
                                                this.messages.zip
                                            )}
                                            value={this.state.fields.zip.value || ''}
                                        />
                                        <div className="invalid-feedback">
                                            <FormattedMessage
                                                id="signup.org.zip.req"
                                                defaultMessage="Zip code is required."
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="form-row mt-5">
                                <div className="col-sm-6">
                                    <label className="text-muted">
                                        <FormattedMessage
                                            id="signup.org.phone.label"
                                            defaultMessage="Main Phone"
                                        />
                                    </label>
                                    <input
                                        autoComplete="off"
                                        className={`form-control ${
                                            this.state.fields.phone.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                        }`}
                                        name="phone"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder={this.props.intl.formatMessage(
                                            this.messages.phoneFormat
                                        )}
                                        value={this.state.fields.phone.value || ''}
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage
                                            id="signup.org.phone.req"
                                            defaultMessage="A valid phone number is required."
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row mt-5">
                                <div className="col-sm-6">
                                    <label className="text-muted">
                                        <FormattedMessage
                                            id="signup.org.email.label"
                                            defaultMessage="Email"
                                        />
                                    </label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.email.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                        }`}
                                        name="email"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder="mail@account.com"
                                        value={this.state.fields.email.value || ''}
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage
                                            id="signup.org.email.req"
                                            defaultMessage="An email is required."
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-6">
                                    <label className="text-muted">
                                        <FormattedMessage
                                            id="signup.org.web.label"
                                            defaultMessage="Website"
                                        />
                                    </label>
                                    <input
                                        className={`form-control ${
                                            this.state.fields.website.isValid() === false
                                                ? 'is-invalid'
                                                : ''
                                        }`}
                                        name="website"
                                        onChange={this.handleInputChange}
                                        type="text"
                                        placeholder="http://"
                                        value={this.state.fields.website.value || ''}
                                    />
                                    <div className="invalid-feedback">
                                        <FormattedMessage
                                            id="signup.org.web.req"
                                            defaultMessage="A website is required."
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="form-row mt-5">
                            <div className="col">
                                <label className="text-muted"><FormattedMessage id="signup.org.logo.label" defaultMessage="Logo" /></label>
                                <FileSelector handleFileChange={this.handleLogoChange} />
                                <div className="invalid-feedback">
                                    <FormattedMessage id="signup.org.logo.req" defaultMessage="Please upload or select a logo for your oganization." />
                                </div>
                            </div>
                            <div className="col">
                                <label className="text-muted row">Or</label>
                                <div className="row">
                                    {this.renderPresetIcons()}
                                </div>
                            </div>
                        </div> */}
                        </div>
                    </div>
                    <div className="row border-top mt-5">{this.renderSubmit()}</div>
                </div>
            </section>
        );
    }
}

export default injectIntl<IProps>(CreateOrganization);



// WEBPACK FOOTER //
// ./src/client/create/Organization.tsx